import { Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import React from "react";
import { useStyles } from "../Common/CommonStyle";
import DialogBox from "../Common/DialogBox";
import VideoPlayer from "../Common/VideoPlayer";
export interface IDisconnectProcess {
  displayNextSlide: () => void;
  type?: number;
  fullWidthConsole?: boolean;
}

const DisconnectProcess = (props: IDisconnectProcess) => {
  const classes = useStyles();
  React.useEffect(() => {
    const timer = setTimeout(() => {
      props.displayNextSlide();
    }, 5000);
    return () => {
      clearTimeout(timer);
    };
  });

  return (
    <div
      className={classes.positionComponent}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <VideoPlayer
        videoURL={"asset/video/ScanningProgressVideo.mp4"}
        displayNextSlide={() => {}}
        styles={
          props?.fullWidthConsole
            ? {
                position: "absolute",
                left: "27%",
                top: "8rem",
                marginTop: "0rem",
                height: "55%",
                width: "70%",
              }
            : {
                position: "absolute",
                left: "5%",
                top: "11%",
                marginTop: "7.5rem",
                height: "20%",
                width: "40%",
              }
        }
      />
      <DialogBox
        childProps={
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              height: "inherit",
              width: "inherit",
            }}
          >
            <CircularProgress
              sx={{
                height: "10rem",
                width: "10rem",
                color: "#56CCF2",
              }}
            />
            <Typography
              variant="body1"
              sx={{ fontWeight: "600", color: "#56CCF2" }}
            >
              {props?.type === 1
                ? "Restoring backups..."
                : "Disconnecting outside networks..."}
            </Typography>
          </div>
        }
        type={3}
      />
    </div>
  );
};

export default DisconnectProcess;
